import React from "react";
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import { ResponsiveBar } from "@nivo/bar";
import { Typography } from "@material-ui/core";

interface Props extends WithStyles<typeof styles> {
  data: any;
  keys: any;
  indexBy: any;
  legendAxisLeft: any;
  legendAxisBelow: any;
  colors?: any;
  useTick?: any;
  size?: any;
  showLabels?: any;
  hideLengends?: any;
  customLengends?: any;
}
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
    },
  });
class BarGraphComponentV2 extends React.Component<Props> {
  textWrap = (tick: any, textAnchor: any) => {
    const MAX_LINE_LENGTH = 20;
    const MAX_LINES = 5;
    const LENGTH_OF_ELLIPSIS = 3;
    const TRIM_LENGTH = MAX_LINE_LENGTH * MAX_LINES - LENGTH_OF_ELLIPSIS;
    const trimWordsOverLength = new RegExp(`^(.{${TRIM_LENGTH}}[^\\w]*).*`);
    const groupWordsByLength = new RegExp(
      `([^\\s].{0,${MAX_LINE_LENGTH}}(?=[\\s\\W]|$))`,
      "gm"
    );
    const splitValues = tick.value
      .replace(trimWordsOverLength, "$1...")
      .match(groupWordsByLength)
      .slice(0, 2)
      .map((val: any, i: any) => (
        <tspan
          key={val}
          dy={20}
          x={0}
          style={{
            fontFamily: "sans-serif",
            fontSize: "10px",
          }}
        >
          {val}
        </tspan>
      ));
    return (
      <g transform={`translate(${tick.x},${tick.y + 20}) rotate(325)`}>
        <text
          alignmentBaseline={tick.textBaseline}
          textAnchor={tick.textAnchor}
        >
          {splitValues}
        </text>
      </g>
    );
  };

  HorizontalTick = (tick: any) => {
    const MAX_LINE_LENGTH = 20;
    const MAX_LINES = 5;
    const LENGTH_OF_ELLIPSIS = 3;
    const TRIM_LENGTH = MAX_LINE_LENGTH * MAX_LINES - LENGTH_OF_ELLIPSIS;
    const trimWordsOverLength = new RegExp(`^(.{${TRIM_LENGTH}}[^\\w]*).*`);
    const groupWordsByLength = new RegExp(
      `([^\\s].{0,${MAX_LINE_LENGTH}}(?=[\\s\\W]|$))`,
      "gm"
    );
    const splitValues = tick.value
      .replace(trimWordsOverLength, "$1...")
      .match(groupWordsByLength)
      .slice(0, 2)
      .map((val: any, i: any) => (
        <tspan
          key={val}
          dy={20}
          x={0}
          style={{ fontFamily: "sans-serif", fontSize: "10px" }}
        >
          {val}
        </tspan>
      ));
    return (
      <g transform={`translate(${tick.x},${tick.y})`}>
        <text alignmentBaseline={tick.textBaseline} textAnchor={"middle"}>
          {splitValues}
        </text>
      </g>
    );
  };
  render() {
    const {
      classes,
      data,
      keys,
      indexBy,
      legendAxisBelow,
      legendAxisLeft,
      colors,
      useTick,
      size,
      showLabels,
      hideLengends,
      customLengends,
    } = this.props;
    return (
      <div
        className={classes.root}
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <ResponsiveBar
          data={data}
          keys={keys}
          indexBy={indexBy}
          margin={{
            top: 50,
            right: hideLengends ? 30 : 130,
            bottom: size === "L" ? 150 : 100,
            left: 60,
          }}
          padding={0.3}
          groupMode="grouped"
          colors={
            colors
              ? colors
              : ["hsl(209, 100%, 50%)", "red", "hsl(359, 70%, 50%)"]
          }
          defs={[
            {
              id: "dots",
              type: "patternDots",
              background: "inherit",
              color: "#ffffff",
              size: 4,
              padding: 1,
              stagger: true,
            },
            {
              id: "lines",
              type: "patternLines",
              background: "inherit",
              color: "#ffffff",
              rotation: -45,
              lineWidth: 6,
              spacing: 10,
            },
          ]}
          borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
          axisTop={null}
          axisRight={null}
          axisBottom={
            useTick
              ? {
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: legendAxisBelow,
                  legendPosition: "middle",
                  legendOffset: 80,
                  renderTick: (tick) =>
                    tick && tick.value ? this.textWrap(tick, "middle") : "",
                }
              : {
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: -35,
                  legend: legendAxisBelow,
                  legendPosition: "middle",
                  legendOffset: size === "L" ? 120 : 80,
                }
          }
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: legendAxisLeft,
            legendPosition: "middle",
            legendOffset: -50,
            format: (e: any) => {
              return Math.floor(e) === e && e;
            },
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          enableLabel={showLabels}
          labelTextColor={"#ffffff"}
          tooltip={(toolTip) => {
            const { id, value, indexValue, color } = toolTip;
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: color,
                    marginRight: 10,
                    width: 15,
                    height: 15,
                  }}
                />
                <Typography style={{ fontSize: 14 }} variant={"caption"}>{`- ${
                  toolTip.data.subCategory ? toolTip.data.subCategory : id
                } ${indexValue}:`}</Typography>
                <strong>{value}</strong>
              </div>
            );
          }}
          legends={
            hideLengends
              ? []
              : [
                  {
                    dataFrom: "keys",
                    anchor: "bottom-right",
                    direction: "column",
                    justify: false,
                    translateX: 50,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 20,
                    itemHeight: 20,
                    itemDirection: "left-to-right",
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]
          }
          animate={true}
          motionStiffness={90}
          motionDamping={15}
        />
        {hideLengends && (
          <div
            style={{
              position: "absolute",
              bottom: 80,
              right: 0,
            }}
          >
            {customLengends.map((item: any) => {
              return (
                <div
                  style={{
                    display: "flex",
                    margin: 20,
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      backgroundColor: item.color,
                    }}
                  />
                  <Typography style={{ fontSize: 10 }}>{item.label}</Typography>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
export default withStyles(styles)(BarGraphComponentV2);
